import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { Button } from '@/components/ui/button';

const BRAND = { color: '#1e3a5f' };

const TermsConditions = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-white">
      <nav className="border-b border-slate-200 bg-white">
        <div className="max-w-4xl mx-auto px-4 py-4 flex items-center gap-3">
          <Button variant="ghost" size="sm" onClick={() => navigate('/')}><ArrowLeft className="w-4 h-4 mr-1" />Volver</Button>
          <div className="flex items-center gap-2">
            <img src="/macropago-logo.jpeg" alt="MacroPago" className="w-8 h-8 rounded-lg object-cover" />
            <span className="text-lg font-bold" style={{ color: BRAND.color, fontFamily: 'Manrope' }}>MacroPago</span>
          </div>
        </div>
      </nav>

      <div className="max-w-4xl mx-auto px-4 py-12">
        <h1 className="text-3xl font-bold text-slate-900 mb-2" style={{ fontFamily: 'Manrope' }}>Terminos y Condiciones</h1>
        <p className="text-sm text-slate-500 mb-8">Ultima actualizacion: Febrero 2026</p>

        <div className="prose prose-slate max-w-none space-y-6 text-slate-700 leading-relaxed">
          <section>
            <h2 className="text-xl font-semibold text-slate-900 mb-3">1. Descripcion del Servicio</h2>
            <p>MacroPago es una plataforma de gestion de cobranzas que permite a empresas administrar carteras de deuda, enviar comunicaciones a clientes, procesar pagos y generar reportes de recupero. El servicio se presta bajo la modalidad SaaS (Software como Servicio).</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-slate-900 mb-3">2. Registro y Acceso</h2>
            <p>El acceso a la plataforma esta restringido a usuarios autorizados mediante autenticacion con cuenta de Google. La empresa contratante es responsable de gestionar los accesos de sus usuarios y de mantener la confidencialidad de sus credenciales.</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-slate-900 mb-3">3. Uso del Servicio</h2>
            <p>El usuario se compromete a:</p>
            <ul className="list-disc pl-6 space-y-1 text-sm">
              <li>Utilizar la plataforma conforme a la legislacion vigente en Argentina.</li>
              <li>No utilizar el servicio para actividades ilegales o abusivas.</li>
              <li>Mantener actualizada la informacion de su empresa y clientes.</li>
              <li>Cumplir con las normativas de proteccion de datos personales (Ley 25.326).</li>
              <li>No intentar acceder a datos de otras empresas o usuarios.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-slate-900 mb-3">4. Procesamiento de Pagos</h2>
            <p>Los pagos procesados a traves de la plataforma son gestionados por procesadores de pago externos (Mercado Pago y otros). MacroPago actua como intermediario tecnologico y no es responsable por demoras o errores en el procesamiento de pagos por parte de estos proveedores.</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-slate-900 mb-3">5. Comunicaciones</h2>
            <p>La plataforma permite el envio de comunicaciones (WhatsApp, email) a clientes. La empresa contratante es la unica responsable del contenido y frecuencia de dichas comunicaciones, debiendo cumplir con la normativa aplicable.</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-slate-900 mb-3">6. Propiedad Intelectual</h2>
            <p>Todos los derechos de propiedad intelectual sobre la plataforma MacroPago, incluyendo software, diseno, marcas y contenido, son propiedad exclusiva de sus titulares. Los datos cargados por las empresas son propiedad de las mismas.</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-slate-900 mb-3">7. Limitacion de Responsabilidad</h2>
            <p>MacroPago no sera responsable por danos indirectos, incidentales o consecuentes derivados del uso de la plataforma. El servicio se proporciona "tal como esta" y no se garantiza disponibilidad ininterrumpida.</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-slate-900 mb-3">8. Modificaciones</h2>
            <p>MacroPago se reserva el derecho de modificar estos terminos y condiciones en cualquier momento. Los cambios seran notificados a los usuarios con 30 dias de antelacion a traves de la plataforma.</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-slate-900 mb-3">9. Jurisdiccion</h2>
            <p>Estos terminos se rigen por las leyes de la Republica Argentina. Cualquier controversia sera sometida a los tribunales ordinarios de la Ciudad Autonoma de Buenos Aires.</p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default TermsConditions;
